import styled from '@emotion/styled';
import PropTypes from 'prop-types';

const SCROLL_NAV_UP_SRC = '/nta-experience/scroll-nav-up.svg';
const SCROLL_NAV_DOWN_SRC = '/nta-experience/scroll-nav-down.svg';
const SCROLL_NAV_SIZE = 32;

export const NtaScrollNavSlot = styled.div`
  width: ${SCROLL_NAV_SIZE}px;
  height: ${SCROLL_NAV_SIZE}px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const NavButton = styled.button`
  border: none;
  padding: 0;
  background: transparent;
  cursor: pointer;
  display: block;
  flex-shrink: 0;
`;

const NavIcon = styled.img`
  display: block;
  width: 32px;
  height: 32px;
`;

const NtaScrollNavButton = ({ direction, onClick }) => {
  const isDown = direction === 'down';

  return (
    <NavButton
      type="button"
      aria-label={isDown ? 'Scroll to bottom' : 'Scroll to top'}
      onClick={onClick}
    >
      <NavIcon
        src={isDown ? SCROLL_NAV_DOWN_SRC : SCROLL_NAV_UP_SRC}
        width={SCROLL_NAV_SIZE}
        height={SCROLL_NAV_SIZE}
        alt=""
      />
    </NavButton>
  );
};

NtaScrollNavButton.propTypes = {
  direction: PropTypes.oneOf(['up', 'down']).isRequired,
  onClick: PropTypes.func.isRequired
};

export default NtaScrollNavButton;
